import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateTimeField from '../../../bootstrap-datetimepicker';
import config from '../../../../config';
class ToDate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateInputFormat: config.dateFormatTimeline,
    };
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
  }
  onBlur() {
    if (this.props.isValid) {
      this.setState({
        dateInputFormat: config.dateFormatTimeline,
      });
    }
  }
  onFocus() {
    this.setState({
      dateInputFormat: config.dateFormatSlash,
    });
  }
  onChange(date) {
    this.props.handleDateChange(date, this.state.dateInputFormat);
  }

  render() {
    const { date, minDate, maxDate } = this.props;
    const { dateInputFormat } = this.state;
    const dateInputProps = {
      onBlur: this.onBlur,
      onFocus: this.onFocus,
    };
    return (
      <div className="filter__choose-date" aria-label="To Date">
        <div className="filter__menu-calender">
          <DateTimeField
            ref="toDate"
            mode="date"
            viewMode="days"
            minDate={minDate}
            maxDate={maxDate}
            dateTime={date}
            format={dateInputFormat}
            inputFormat={dateInputFormat}
            onChange={this.onChange}
            inputProps={dateInputProps}
          />
        </div>
      </div>
    );
  }
}
ToDate.defaulValue = {
  isValid: true,
};
ToDate.propTypes = {
  handleDateChange: PropTypes.func.isRequired,
  date: PropTypes.shape({}).isRequired,
  minDate: PropTypes.shape({}).isRequired,
  maxDate: PropTypes.shape({}).isRequired,
  isValid: PropTypes.bool,
};
export default ToDate;
